import { Menu, Modal } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
// history removed in favor of native navigation
import { signOutStaffSession } from 'api-calls/sign-in';
import { useAdminAccount } from 'hooks/use-admin-account';
import { deleteToken } from 'utils/auth';

const UserMenu = ({ user }) => {
  const navigate = useNavigate();
  const { data: account } = useAdminAccount();
  // Admins who sign in with Google may have no password yet: offer to create
  // one. Those who already have one can change it.
  const passwordItem = account?.has_password
    ? {
        key: 'change_password',
        label: <Link to={'/change-password'}>Đổi mật khẩu</Link>,
      }
    : {
        key: 'create_password',
        label: <Link to={'/create-password'}>Tạo mật khẩu</Link>,
      };
  return (
    <Menu
      selectedKeys={['account']}
      disabledOverflow={true}
      mode="horizontal"
      items={[
        {
          label: `My Account (${user.email})`,
          key: 'account',
          children: [
            passwordItem,
            {
              key: 'security',
              label: <Link to={'/security'}>Bảo mật tài khoản</Link>,
            },
            {
              key: 'logout',
              label: (
                <div
                  onClick={() =>
                    Modal.confirm({
                      title: 'Are you sure you want to logout?',
                      onOk: async () => {
                        await signOutStaffSession();
                        deleteToken();
                        window.location.href = '/login';
                      },
                    })
                  }
                >
                  Logout
                </div>
              ),
            },
          ],
        },
      ]}
    />
  );
};

export default UserMenu;
